import { render } from "./AlertBox.vue?vue&type=template&id=74ac33ae&scoped=true"
import script from "./AlertBox.vue?vue&type=script&lang=js"
export * from "./AlertBox.vue?vue&type=script&lang=js"

import "./AlertBox.vue?vue&type=style&index=0&id=74ac33ae&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Carla\\Projects\\Personal\\my-personal-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ac33ae"]])

export default __exports__